import UpdateWallet from "../../../../components/@wallets/wallets/UpdateWallet";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WalletUpdatePage() {

    return UpdateWallet({
        routeType: routeTypes.admin
    })
}       